import React from 'react';
import EmojiIcon from './Emoji';
export var createEmojiIcon = function (code) {
    var EmojiComponent = function (props) {
        return <EmojiIcon code={code} {...props}/>;
    };
    EmojiComponent.displayName = "EmojiIcon_".concat(code);
    return EmojiComponent;
};
